/* ============================================================
   MARZ CUSTOM CODE — 21 Golf Range
   All JS for custom sections lives here.

   Index:
     1. Promo Rail init — sections/promo-rail.liquid
        (arrows, progress bar, autoplay, entrance animation,
         theme-editor re-init)
   ============================================================ */

(function () {
  'use strict';

  /* ================= 1. PROMO RAIL ================= */

  function initPromoRail(section) {
    var rail = section.querySelector('[data-pr-rail]');
    if (!rail) return;
    section.dataset.prInit = '1';

    var cards = rail.querySelectorAll('.pr__card');
    var fill = section.querySelector('[data-pr-progress]');
    var arrows = section.querySelectorAll('[data-pr-arrow]');
    var autoplay = section.dataset.autoplay === 'true';
    var delay = parseInt(section.dataset.delay, 10) || 5000;

    /* entrance stagger */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var i = Array.prototype.indexOf.call(cards, e.target);
            setTimeout(function () { e.target.classList.add('pr--in'); }, (i % 3) * 110);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.2 });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('pr--in'); });
    }

    function cardStep() {
      if (!cards.length) return 0;
      var gap = parseFloat(getComputedStyle(rail).gap) || 20;
      return cards[0].getBoundingClientRect().width + gap;
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        rail.scrollBy({ left: cardStep() * Number(btn.dataset.prArrow), behavior: 'smooth' });
      });
    });

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (fill) {
        var pct = max > 0 ? rail.scrollLeft / max : 1;
        fill.style.width = Math.max(8, pct * 100) + '%';
      }
      if (arrows.length === 2) {
        arrows[0].disabled = rail.scrollLeft < 10;
        arrows[1].disabled = rail.scrollLeft > max - 10;
        var hide = max <= 2;
        arrows.forEach(function (a) { a.style.display = hide ? 'none' : ''; });
      }
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* autoplay (disabled in theme editor via data-autoplay="false") */
    var timer = null;
    function tick() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 2) return;
      if (rail.scrollLeft >= max - 10) {
        rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        rail.scrollBy({ left: cardStep(), behavior: 'smooth' });
      }
    }
    function start() { if (autoplay && !timer) timer = setInterval(tick, delay); }
    function stop() { clearInterval(timer); timer = null; }
    start();
    ['mouseenter', 'touchstart', 'pointerdown'].forEach(function (ev) {
      rail.addEventListener(ev, stop, { passive: true });
    });
    rail.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  }

  function initAllPromoRails(root) {
    (root || document).querySelectorAll('[data-promo-rail]:not([data-pr-init])').forEach(initPromoRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllPromoRails(); });
  } else {
    initAllPromoRails();
  }

  /* Shopify theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initAllPromoRails(e.target);
  });
})();
